var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import React, { useEffect, useState } from 'react';
import { styles, headerStyle, weekHeaderStyle } from './GridComponent.styles';
import { DataGrid } from '@verge-vcl-react/data-grid';
import GridCellComponent from '../GridCellComponent/GridCellComponent';
import { CheckboxVisibility } from '@fluentui/react';
import { useSelector } from 'react-redux';
import RowHeaderComponent from '../RowHeaderComponent/RowHeaderComponent';
import { dailyGrainDateListSelector } from '../../store/Slices/DateNavigationSlice';
import { NonProjectHeaderComponent } from '../NonProjectHeaderComponent/NonProjectHeaderComponent';
import moment from 'moment/moment';
import LoaderComponent from '../LoaderComponent/LoaderComponent';
import GridGroupHeaderComponent from '../GridGroupHeaderComponent/GridGroupHeaderComponent';
import { assignmentForecastHoursTransformDataSelector, nonProjectDetailsTransformDataSelector, nonProjectsAggregatedDataSelector, projectsAggregatedDataSelector, assignmentDetailsSelector } from '../../store/Slices/AssignmentDetailsSlice';
import { useAppSelector } from '../../store/app.store';
const GridComponent = ({ isPastView }) => {
    const [AvailabilityRowNames, setAvailabilityRowNames] = useState([]);
    const [AvailabilityColumnNames, setAvailabilityColumnNames] = useState([]);
    const [NPAvailabilityRowNames, setNPAvailabilityRowNames] = useState([]);
    const [NPAvailabilityColumnNames, setNPAvailabilityColumnNames] = useState([]);
    const [NPAggregatedValues, setNPAggregatedValues] = useState([]);
    const [CESAggregatedValues, setCESAggregatedValues] = useState([]);
    const rawGridData = useAppSelector(assignmentForecastHoursTransformDataSelector);
    const rawGridDataForNP = useSelector(nonProjectDetailsTransformDataSelector);
    const aggregatedProjectData = useSelector(projectsAggregatedDataSelector);
    const aggregatedDataForNP = useSelector(nonProjectsAggregatedDataSelector);
    /*const aggregatedDataForNPPastView = useSelector(laborNPAggregatedHoursSelector);
    const dateHeader = useSelector(fiscalWeekStartDateListSelector);
    //const isAdditionalDetailsEnabled = useSelector(selectReviewPJMForecastState);
    const isAdditionalDetailsEnabled = false; // TODO: Update this line to use the correct selector or value
    const isISDForecastLoadingSelectorFlag = useSelector(isISDForecastLoadingSelector);
    const isNPForecastLoadingSelectorFlag = useSelector(isNPForecastLoadingSelector);
    const assignmentDetails = useSelector(assignmentDetailsSelector);*/
    const dateHeader = useSelector(dailyGrainDateListSelector);
    //const aggregatedDataForISD = [];
    //const aggregatedDataForNP = [];
    //const aggregatedDataForNPPastView = [];
    const isISDForecastLoadingSelectorFlag = false;
    const isNPForecastLoadingSelectorFlag = false;
    const isAdditionalDetailsEnabled = false;
    const assignmentDetails = useSelector(assignmentDetailsSelector);
    const [npGroups, setNpGroups] = useState([
        {
            key: 'Overhead Non-Project Hours',
            name: 'Overhead Non-Project Hours',
            startIndex: 0,
            count: rawGridDataForNP.length,
            level: 0,
            isCollapsed: isPastView,
        },
    ]);
    const [groups, setGroups] = useState([
        {
            key: 'Project Assignments',
            name: 'Project Assignments',
            startIndex: 0,
            count: rawGridData.length,
            level: 0,
            isCollapsed: false,
        },
    ]);
    const setNPGridRowData = () => {
        let availabilityGridData = [];
        const dailyDateList = dateHeader; // MODIFIED: Use dailyDateList
        const numDays = dailyDateList.length; // MODIFIED: numDays instead of numWeeks
        rawGridDataForNP.forEach((rowItem) => {
            const newRow = {
                rowId: rowItem.rowId.toString(),
                rowName: rowItem.rowId.toString(),
                rowIndex: rowItem.rowIndex,
                rowType: rowItem.rowType,
                rowData: Array.from({ length: numDays }, () => ({
                    columnId: '',
                    columnName: '',
                    columnIndex: 0,
                    columnData: {
                        gridCellType: '',
                        primaryValue: '',
                        additionalDetails: '',
                        isAdditionalDetailsEnabled: false,
                        isInputDisabled: true,
                        rowId: '',
                        columnId: '',
                        isPastView: false,
                    },
                })),
            };
            dailyDateList.forEach(// MODIFIED: Iterate over dailyDateList
            (dailyDateListItem, index) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                const columnItem = rowItem.rowData.find((column) => column.columnId === dailyDateListItem // MODIFIED: dailyDateListItem
                );
                if (columnItem) {
                    const newColumn = {
                        columnId: (_a = columnItem.columnId) !== null && _a !== void 0 ? _a : '',
                        columnName: (_b = columnItem.columnName) !== null && _b !== void 0 ? _b : '',
                        columnIndex: (_c = columnItem.columnIndex) !== null && _c !== void 0 ? _c : 0,
                        columnData: {
                            gridCellType: 'nonproject',
                            primaryValue: (_e = (_d = columnItem.columnData) === null || _d === void 0 ? void 0 : _d.primaryValue) !== null && _e !== void 0 ? _e : '-',
                            additionalDetails: (_g = (_f = columnItem.columnData) === null || _f === void 0 ? void 0 : _f.additionalDetails) !== null && _g !== void 0 ? _g : '',
                            isAdditionalDetailsEnabled: (_j = (_h = columnItem.columnData) === null || _h === void 0 ? void 0 : _h.isAdditionalDetailsEnabled) !== null && _j !== void 0 ? _j : false,
                            isInputDisabled: true,
                            rowId: rowItem.rowId.toString(),
                            columnId: columnItem.columnId.toString(),
                            isPastView: isPastView,
                        },
                    };
                    newRow.rowData[index] = newColumn;
                }
                else {
                    const newColumn = {
                        columnId: dailyDateListItem,
                        columnName: '',
                        columnIndex: index,
                        columnData: {
                            gridCellType: 'nonproject',
                            primaryValue: '-',
                            additionalDetails: '',
                            isAdditionalDetailsEnabled: false,
                            isInputDisabled: true,
                            rowId: rowItem.rowId.toString(),
                            columnId: dailyDateListItem,
                            isPastView: isPastView,
                        },
                    };
                    newRow.rowData[index] = newColumn;
                }
            });
            availabilityGridData.push(newRow);
        });
        return availabilityGridData;
    };
    const setGridRowData = () => {
        let availabilityGridData = [];
        const dailyDateList = dateHeader; // MODIFIED: Use dailyDateList
        const numDays = dailyDateList.length; // MODIFIED: numDays instead of numWeeks
        rawGridData.forEach((rowItem) => {
            let gridCellType = rowItem.rowId === '0' ? 'nuance' : 'isd';
            const newRow = {
                rowId: rowItem.rowId.toString(),
                rowName: rowItem.rowId.toString(),
                rowIndex: rowItem.rowIndex,
                rowType: rowItem.rowType,
                rowData: Array.from({ length: numDays }, () => ({
                    columnId: '',
                    columnName: '',
                    columnIndex: 0,
                    columnData: {
                        gridCellType: '',
                        primaryValue: '',
                        additionalDetails: '',
                        isAdditionalDetailsEnabled: isAdditionalDetailsEnabled,
                        isInputDisabled: true,
                        rowId: '',
                        columnId: '',
                        isPastView: false,
                        lastUpdatedBy: '',
                    },
                })),
            };
            dailyDateList.forEach(//Iterate over dailyDateList
            (dailyDateListItem, index) => {
                var _a, _b, _c, _d, _e;
                const columnItem = rowItem.rowData.find((column) => column.columnId === dailyDateListItem // MODIFIED: dailyDateListItem
                );
                if (columnItem) {
                    const newColumn = {
                        columnId: columnItem.columnId,
                        columnName: columnItem.columnName,
                        columnIndex: index,
                        columnData: {
                            gridCellType: gridCellType,
                            primaryValue: (_b = (_a = columnItem.columnData) === null || _a === void 0 ? void 0 : _a.primaryValue) !== null && _b !== void 0 ? _b : (isUpdateForecastDisabled(dailyDateListItem, rowItem.rowId.toString()) ? '-' : '0'),
                            additionalDetails: (_d = (_c = columnItem.columnData) === null || _c === void 0 ? void 0 : _c.additionalDetails) !== null && _d !== void 0 ? _d : '',
                            isAdditionalDetailsEnabled: gridCellType === 'isd' ? isAdditionalDetailsEnabled : false,
                            isInputDisabled: isUpdateForecastDisabled(dailyDateListItem, // MODIFIED: dailyDateListItem
                            rowItem.rowId.toString()),
                            rowId: rowItem.rowId.toString(),
                            columnId: columnItem.columnId.toString(),
                            isPastView: isPastView,
                            lastUpdatedBy: (_e = columnItem.columnData) === null || _e === void 0 ? void 0 : _e.lastUpdatedBy,
                        },
                    };
                    newRow.rowData[index] = newColumn;
                }
                else {
                    const newColumn = {
                        columnId: dailyDateListItem,
                        columnName: '',
                        columnIndex: index,
                        columnData: {
                            gridCellType: gridCellType,
                            primaryValue: isUpdateForecastDisabled(dailyDateListItem, rowItem.rowId.toString()) ? '-' : '0',
                            additionalDetails: '',
                            isAdditionalDetailsEnabled: gridCellType === 'isd' ? isAdditionalDetailsEnabled : false,
                            isInputDisabled: isUpdateForecastDisabled(dailyDateListItem, rowItem.rowId.toString()),
                            rowId: rowItem.rowId.toString(),
                            columnId: dailyDateListItem,
                            isPastView: isPastView,
                            lastUpdatedBy: '',
                        },
                    };
                    newRow.rowData[index] = newColumn;
                }
            });
            availabilityGridData.push(newRow);
        });
        return availabilityGridData;
    };
    const setNPGridColumnData = () => {
        const dailyDateList = dateHeader; // MODIFIED: Use dailyDateList
        let availabilityColumnDataArray = [
            {
                styles: headerStyle,
                key: 'availabilityGrid',
                name: 'NP Type',
                fieldName: 'rowName',
                type: 'primaryText',
                isResizable: false,
                ariaLabel: 'NP Type',
                minColumnWidth: 600,
                maxWidth: 620,
                onRender: (item) => (React.createElement(NonProjectHeaderComponent, { key: item.rowId, nprequestId: item.rowId, isNonProject: item.rowType.toLowerCase() === 'nonproject', isPublicHoliday: item.rowType.toLowerCase() === 'publicholiday', isVacation: item.rowType.toLowerCase() === 'vacation', isOutlook: item.rowType.toLowerCase() === 'outlook' })),
            },
        ];
        dailyDateList.forEach((day, index) => {
            let currentDayDisplay = moment(day).format('MMM D'); // Format for daily display
            const newColumn = {
                styles: weekHeaderStyle,
                key: `day${index}`,
                name: currentDayDisplay,
                fieldName: `rowData`,
                type: 'text',
                isResizable: false,
                ariaLabel: moment(day).format('MMM D, YYYY'),
                getValue: (item) => {
                    var _a, _b;
                    return ((_b = (_a = item.rowData[index]) === null || _a === void 0 ? void 0 : _a.columnData) === null || _b === void 0 ? void 0 : _b.primaryValue) || '';
                },
                onRender: (item) => (React.createElement(GridCellComponent, { key: item.rowId + '-' + index, cellDetails: item.rowData[index].columnData })),
            };
            availabilityColumnDataArray.push(newColumn);
        });
        return availabilityColumnDataArray;
    };
    const setGridColumnData = () => {
        const dailyDateList = dateHeader; // MODIFIED: Use dailyDateList
        let availabilityColumnDataArray = [
            {
                styles: headerStyle,
                key: 'availabilityGrid',
                name: 'Assignment Type',
                fieldName: 'rowName',
                type: 'primaryText',
                isResizable: false,
                ariaLabel: 'Assignment Type',
                minColumnWidth: 600,
                maxWidth: 620,
                onRender: (item) => (React.createElement(RowHeaderComponent, { key: item.rowId, rowIdentifier: Number(item.rowId), isPastView: isPastView })),
            },
        ];
        dailyDateList.forEach((day, index) => {
            let currentDayDisplay = moment(day).format('MMM D'); // MODIFIED: Format for daily display
            const newColumn = {
                styles: weekHeaderStyle,
                key: `day${index}`,
                name: currentDayDisplay,
                fieldName: `rowData`,
                type: 'text',
                isResizable: false,
                ariaLabel: moment(day).format('MMM D, YYYY'),
                onRender: (item) => (React.createElement(GridCellComponent, { key: item.rowId + '-' + index, cellDetails: item.rowData[index].columnData })),
            };
            availabilityColumnDataArray.push(newColumn);
        });
        return availabilityColumnDataArray;
    };
    useEffect(() => {
        let NPAggregatedData = [];
        NPAggregatedData = Object.values(aggregatedDataForNP).map(item => Math.floor(item));
        setNPAggregatedValues(NPAggregatedData);
    }, [aggregatedDataForNP]);
    useEffect(() => {
        let ISDAggregatedData = [];
        ISDAggregatedData = Object.values(aggregatedProjectData).map(item => Math.floor(item));
        setCESAggregatedValues(ISDAggregatedData);
    }, [aggregatedProjectData]);
    useEffect(() => {
        if (rawGridData != null) {
            setAvailabilityRowNames(setGridRowData());
            setAvailabilityColumnNames(setGridColumnData());
            setGroups(prevGroups => {
                const newGroups = [...prevGroups];
                newGroups[0].count = rawGridData.length;
                return newGroups;
            });
        }
    }, [rawGridData, isAdditionalDetailsEnabled]);
    useEffect(() => {
        if (rawGridDataForNP != null) {
            setNPAvailabilityRowNames(setNPGridRowData());
            setNPAvailabilityColumnNames(setNPGridColumnData());
            setNpGroups(prevGroups => {
                const newGroups = [...prevGroups];
                newGroups[0].count = rawGridDataForNP.length;
                return newGroups;
            });
        }
    }, [rawGridDataForNP]);
    function isUpdateForecastDisabled(dailyDateItem, // MODIFIED: Parameter name
    requestId) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const assignmentDetail = assignmentDetails.eventDetails.find(e => e.customProperties.ResourceRequestId.toString() === requestId);
        if (!assignmentDetail)
            return true;
        if (((_a = assignmentDetail === null || assignmentDetail === void 0 ? void 0 : assignmentDetail.customProperties) === null || _a === void 0 ? void 0 : _a.ResourceRequestStatusEnum) != "Assigned")
            return true;
        const projectStartDateString = ((_b = assignmentDetail === null || assignmentDetail === void 0 ? void 0 : assignmentDetail.customProperties) === null || _b === void 0 ? void 0 : _b.IsFlexiDateRequest) === "true" ? (((_c = assignmentDetail === null || assignmentDetail === void 0 ? void 0 : assignmentDetail.customProperties) === null || _c === void 0 ? void 0 : _c.RequestedStartDate) ? moment((_d = assignmentDetail === null || assignmentDetail === void 0 ? void 0 : assignmentDetail.customProperties) === null || _d === void 0 ? void 0 : _d.RequestedStartDate).format('YYYY-MM-DD')
            : null) : (((_e = assignmentDetail === null || assignmentDetail === void 0 ? void 0 : assignmentDetail.customProperties) === null || _e === void 0 ? void 0 : _e.ScheduledStartDate) ? moment((_f = assignmentDetail === null || assignmentDetail === void 0 ? void 0 : assignmentDetail.customProperties) === null || _f === void 0 ? void 0 : _f.ScheduledStartDate).format('YYYY-MM-DD') : null);
        // const lastStatusUpdatedDateString = assignmentDetail.LastStatusUpdatedDate
        //   ? moment(assignmentDetail.LastStatusUpdatedDate).format('YYYY-MM-DD')
        //   : null;
        const todayString = moment().format('YYYY-MM-DD');
        let maximumPermissibleEndDateString = null;
        if (((_g = assignmentDetail === null || assignmentDetail === void 0 ? void 0 : assignmentDetail.customProperties) === null || _g === void 0 ? void 0 : _g.IsFlexiDateRequest) === "true") {
            const m = moment((_h = assignmentDetail === null || assignmentDetail === void 0 ? void 0 : assignmentDetail.customProperties) === null || _h === void 0 ? void 0 : _h.RequestedEndDate);
            maximumPermissibleEndDateString = m.isValid() ? m.format('YYYY-MM-DD') : null;
        }
        else {
            const m = moment((_j = assignmentDetail === null || assignmentDetail === void 0 ? void 0 : assignmentDetail.customProperties) === null || _j === void 0 ? void 0 : _j.ProjectEndDate);
            maximumPermissibleEndDateString = m.isValid() ? m.format('YYYY-MM-DD') : null;
        }
        if (!maximumPermissibleEndDateString) {
            return true;
        }
        // // If the assignment was updated today
        // if (lastStatusUpdatedDateString === todayString) {
        //   if (isPastView) return true;
        //   if (projectStartDateString && dailyDateItem < projectStartDateString) return true;
        //   if (maximumPermissibleEndDateString && dailyDateItem > maximumPermissibleEndDateString) return true;
        //   // Allow editing for today or future dates if updated today and within bounds
        //   if (dailyDateItem < todayString) return true; // Still disable past days even if updated today unless it IS today
        //   return false; // Enabled
        // } else {
        // Not updated today
        if (isPastView)
            return true;
        // Disable if it's today (and not updated today)
        //if (dailyDateItem === todayString) return true;
        // Disable if it's a past day
        if (dailyDateItem < todayString)
            return true;
        if (projectStartDateString && dailyDateItem < projectStartDateString)
            return true;
        if (maximumPermissibleEndDateString && dailyDateItem > maximumPermissibleEndDateString)
            return true;
        // If it's a future day, within bounds, not updated today:
        return false; // Enabled
        // }
    }
    function renderEmptyDetailsHeader() {
        return React.createElement("div", null);
    }
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            overflowX: 'hidden',
            height: 'calc(100vh - 292px)',
            minHeight: '290px'
        } },
        (isISDForecastLoadingSelectorFlag ||
            isNPForecastLoadingSelectorFlag) && (React.createElement(LoaderComponent, { primaryText: "Loading availability forecast..." })),
        React.createElement(DataGrid, { styles: styles.dataGridStyles, headerStyles: {
                collapseButton: false,
            }, listConfig: AvailabilityColumnNames, data: isISDForecastLoadingSelectorFlag ? [] : AvailabilityRowNames, checkboxVisibility: CheckboxVisibility.hidden, groups: groups, groupProps: {
                showEmptyGroups: true,
                onToggleCollapseAll(isAllCollapsed) {
                    const newGroup = [...groups];
                    newGroup[0].isCollapsed = isAllCollapsed;
                    setGroups(newGroup);
                    const newNpGroups = [...npGroups];
                    newNpGroups[0].isCollapsed = isAllCollapsed;
                    setNpGroups(newNpGroups);
                },
                onRenderHeader: props => {
                    var _a, _b, _c, _d;
                    if (props && props.group) {
                        props.group.isCollapsed = (_b = (_a = groups[0]) === null || _a === void 0 ? void 0 : _a.isCollapsed) !== null && _b !== void 0 ? _b : false;
                        return (React.createElement(GridGroupHeaderComponent, { groupHeading: groups[0].name, groupLength: rawGridData.length, groupValues: CESAggregatedValues, isPastView: isPastView, onToggleCollapse: (_c = props.onToggleCollapse) !== null && _c !== void 0 ? _c : (() => { }), group: props.group, isCollapsed: (_d = props.group.isCollapsed) !== null && _d !== void 0 ? _d : false }));
                    }
                    else
                        return null;
                },
            } }),
        React.createElement(DataGrid, { styles: styles.dataGridStyles, listConfig: NPAvailabilityColumnNames, data: isNPForecastLoadingSelectorFlag ? [] : NPAvailabilityRowNames, checkboxVisibility: CheckboxVisibility.hidden, groups: npGroups, groupProps: {
                showEmptyGroups: true,
                onRenderHeader: props => {
                    var _a, _b, _c, _d;
                    if (props && props.group) {
                        props.group.isCollapsed = (_b = (_a = npGroups[0]) === null || _a === void 0 ? void 0 : _a.isCollapsed) !== null && _b !== void 0 ? _b : false;
                        return (React.createElement(GridGroupHeaderComponent, { groupHeading: npGroups[0].name, groupLength: rawGridDataForNP.length, groupValues: NPAggregatedValues, isPastView: isPastView, onToggleCollapse: (_c = props.onToggleCollapse) !== null && _c !== void 0 ? _c : (() => { }), group: props.group, isCollapsed: (_d = props.group.isCollapsed) !== null && _d !== void 0 ? _d : false }));
                    }
                    else
                        return null;
                },
            }, onRenderDetailsHeader: renderEmptyDetailsHeader })));
};
export default GridComponent;
//# sourceMappingURL=GridComponent.js.map